import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetCorporateDefenseScoreData } from '../../../utils/toolsCorporateDefenseScoreData-utils';

export const getCorporateDefenseScoreDataReq = createAsyncThunk('getCorporateDefenseScoreDataReq', async () => {
  const response = await GetCorporateDefenseScoreData();
  return response;
});

const CorporateDefenseScoreDataToolSlice = createSlice({
  name: 'corporateDefenseScoreDataTool',
  initialState: {
    tableCorporateDefenseScoreData: [],
    CorporateDefenseScoreDataHeaderTooltips: [],
    //
    isLoadingCorporateDefenseScoreDataTool: true,
  },
  reducers: {
    handleOnResetCorporateDefenseScoreData: {
      reducer(state) {
        state.tableCorporateDefenseScoreData = [];
        state.CorporateDefenseScoreDataHeaderTooltips = [];
        state.isLoadingCorporateDefenseScoreDataTool = true;
      },
      prepare() {
        return {};
      },
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCorporateDefenseScoreDataReq.fulfilled, (state, action) => {
      if (action.payload) {
        state.tableCorporateDefenseScoreData = action.payload !== undefined ? action.payload.data : [];
        state.CorporateDefenseScoreDataHeaderTooltips = action.payload !== undefined ? action.payload.tooltipData : [];
      }
      state.isLoadingCorporateDefenseScoreDataTool = action.payload === undefined;
    });
  },
});

export const { handleOnResetCorporateDefenseScoreData } = CorporateDefenseScoreDataToolSlice.actions;

export default CorporateDefenseScoreDataToolSlice.reducer;
